import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../firebase/AuthProvider";
import Loader from "../components/components/loader/Loader";

const OnboardingGuard = () => {
  const { currentUser, isLoading, requiresOnboarding } = useAuth();

  // Wait for Firebase and the backend login check to complete
  if (isLoading || requiresOnboarding === null) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  // If they are not logged in at all, kick them to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If they are already fully onboarded, kick them to the dashboard
  if (requiresOnboarding === false) {
    return <Navigate to="/home" replace />;
  }

  // Otherwise, they are logged in AND need onboarding -> let them in!
  return <Outlet />;
};

export default OnboardingGuard;